import * as React from "react"
import PropTypes from "prop-types"
// import { Link, useStaticQuery, graphql } from "gatsby"
// import Container from "react-bootstrap/Container"
// import Colonne from "react-bootstrap/Col"
// import Row from "react-bootstrap/Row"
// import Button from "react-bootstrap/Button"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import VideoModal from "./VideoModal"
import useGetVideoQuery from "../queries/videoQueries"

import "./VideoGrid.scss"

const VideoGrid = props => {

  let data = useGetVideoQuery()
  let dataFiltered =  data.allVideo.nodes
  if(props.tags && props.tags.length){
    dataFiltered = data.allVideo.nodes.map(el=>{return{...el, tags : el.tags.map(t=>t.tag)}}).filter(e=>props.tags.every(val => e.tags.includes(val)))
    // data.allVideo.nodes = dataFiltered
  }
  const [modalShow, setModalShow] = React.useState(false)
  const [videoData, setVideoData] = React.useState({
    URI: "",
    title: "",
    description: "",
    tags: [],
  })
  const handleClick = data => {
    setModalShow(true)
    setVideoData(data)
  }

  return (
    <div className="videoGridWrapper">
      <VideoModal
        onHide={() => setModalShow(false)}
        show={modalShow}
        video_data={videoData}
      />
      <div className="parentDiv">
        {dataFiltered.map(video => {
          const imageNode = data.allFile.nodes.filter(
            node => node.parent.id == video.id
          )[0]
          const image = getImage(imageNode)
          return (
            <div className={"buttonWrapper"} key={video.link}>
              <button
                className={"col"}
                onClick={handleClick.bind(null, {
                  URI: video.link,
                  title: video.name,
                  description: video.description,
                })}
              >
                <div className="overlay">
                  <div className="videoInfo">{video.name}</div>
                </div>
                <GatsbyImage image={image} alt={video.name} />
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

VideoGrid.propTypes = {
  aProp: PropTypes.string,
}

VideoGrid.defaultProps = {
  aProp: ``,
}

export default VideoGrid
